import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';

// Components
import Loading from '@/components/Global/Loading.vue';
import Alert from '@/components/Global/Alert.vue';
import SwitchField from '@/components/Form/SwitchField.vue';
import Checkbox from '@/components/Form/CheckboxBoolean.vue';
import SelectField from '@/components/Form/SelectField.vue';
import { IUserRoles, IUserCapabilities } from '@/common/Auth';

import Auth from '@/services/Auth';

@Component({
     name: 'Roles',
     components: {
          Loading,
          Alert,
          SwitchField,
          SelectField,
          Checkbox,
     },
})
export default class Roles extends Vue {
     @Getter('roles', { namespace: 'Misc' }) private roles!: IUserRoles[];
     @Prop({ default: 'col-md-3' }) private columns!: string;
     @Prop([Object, Array]) private permissions: any;
     @Prop({ default: false, type: Boolean, required: false }) private staff: boolean;
     private role: string;
     private capabilities: Partial<IUserCapabilities>;
     private error: boolean;
     private loading: boolean;
     private Auth: typeof Auth = Auth;

     constructor() {
          super();

          this.role = '';
          this.capabilities = this.permissions || {
               ACCOUNT_ADMIN: false,
               BILL_PAY: false,
               COVERAGE_TABLE: false,
               PAYMENT_HISTORY: false,
               REPORT_CLAIM: false,
               STAFF: false,
               VIEW_CLAIMS: false,
               VIEW_CME: false,
               VIEW_COI: false,
               VIEW_CYBER_SOLUTIONS: false,
               VIEW_LATEST_NEWS: false,
               VIEW_POLICY_INFO: false,
               VIEW_RISK_MANAGEMENT: false,
               VIEW_SAVED_QUOTES: false,
          };
          this.error = false;
          this.loading = false;
     }

     @Watch('capabilities', { deep: true })
     private watchCapabilities() {
          this.$emit('update:permissions', this.capabilities);
     }

     private changeRole($event) {
          this.roles.forEach(role => {
               if (role.role_id === $event.target.value) {
                    this.capabilities = {};
                    Object.keys(role.permissions).forEach(key => {
                         this.capabilities[key] = true;
                    });
               }
          });
     }
}
